let taskSyncPromise = null

/** 登录后同步匿名访客与登录用户的视频任务（GET task_sync，cookie 带 uuid，header 带 token） */
export async function syncUserVideoTasks() {
  if (!import.meta.client) return null

  const userStore = useUserStore()
  const token = userStore.token || localStorage.getItem('token') || ''
  if (!token) return null

  if (taskSyncPromise) return taskSyncPromise

  taskSyncPromise = (async () => {
    const [{ ensureGuestIdentity }, { syncUserVideoTasks: syncUserVideoTasksApi }] =
      await Promise.all([
        import('~/utils/requestVerification.js'),
        import('~/composables/api/user.js'),
      ])
    const uuid = ensureGuestIdentity()
    if (!uuid) return null
    return syncUserVideoTasksApi()
  })().finally(() => {
    taskSyncPromise = null
  })

  return taskSyncPromise
}
